import React, { useEffect, useState, useContext } from "react";
import Header from "../header/Header";
import { FaArrowRightLong } from "react-icons/fa6";
function Tracheostomycare() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [duration, setDuration] = useState(1);
  const [pricePerMonth] = useState(500);

  const handleDurationChange = (amount) => {
    const newDuration = duration + amount;
    if (newDuration > 0) {
      setDuration(newDuration);
    }
  };

  const totalPrice = duration * pricePerMonth;
  return (
    <>
      <Header></Header>
      <div class="ssimg1">
        <center>
          <h2>
            <b class="text-dark">
              <br></br>
              <br></br>
              <br></br>
              <br></br>Tracheostomy Care
            </b>
          </h2>
        </center>
      </div>
      <div class="signature-background22">
        <div class="container">
          <br></br>
          <center>
            <h2>
              <b class="text-white">Service Overview</b>
            </h2>
          </center>
          <br></br>
          <center>
            <div class="row">
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/emicon1.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Tube Management & Suctioning</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Maintain tracheostomy tube and clear airways for easier breathing.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/ssicon2.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Wound Care & Vital Signs</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Protect the tracheostomy site and monitor vital health indicators.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/emicon3.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Patient Education & Support:</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Teach patients and caregivers essential tracheostomy care skills.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
          <br/>

          <center>
            <h2>
              <b class="text-white">Customization Options</b>
            </h2>
          </center>
          <br></br>
          <center>
            <div class="viosq">
              <div class="container">
                <form
                  class="booking-form"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group11">
                    <label class="boxresd">Duration Selector:</label>
                    <div
                      class="diaginput"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <span
                        class="subtraction text-dark"
                        onClick={() => handleDurationChange(-1)}
                        style={{
                          position: "absolute",
                          left: 20,
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        -
                      </span>
                      <input
                        class="booktestdur"
                        name="duration"
                        value={`${duration} month${duration > 1 ? "s" : ""}`}
                        readOnly
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "0 40px",
                        }}
                      />
                      <span
                        class="addition text-dark  booktestadd"
                        onClick={() => handleDurationChange(1)}
                        style={{
                          position: "absolute",
                          right: 20,
                          bottom: "0px",
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div class="form-group11">
                    <label class="boxresd">Price:</label>
                    <div class="diaginput" style={{ position: "relative" }}>
                      <input
                        class="booktestdur"
                        style={{ width: "300px" }}
                        type="number"
                        name="totalPrice"
                        value={totalPrice}
                        readOnly
                      />
                    </div>
                      </div>
                      </form>
                <br></br>       
                <center>
                  <button class="custom-btn1 btn-3">
                    <span class="btntexty bookingbtn">Book Now</span>
                  </button>
                </center>
              </div>
            </div>
          </center>
          <br></br>
          <br></br>
          <center>
            {" "}
            <h2>
              <b class="text-white">Service in Detail</b>
            </h2>
          </center>
          <br></br>

          {/* //advantages// */}
          <center>
            <div class="row">
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/armicon1.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Tracheostomy Tube Management</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Ensuring proper placement, cleaning, and maintenance of the tracheostomy tube to prevent complications.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon2.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Suctioning</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Safely removing mucus and secretions to maintain a clear airway and improve breathing.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon3.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Wound Care</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Caring for the area around the tracheostomy to prevent infection and promote healing.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
          <br></br>

          <center>
            <div class="row">
              <div class="col-sm-6">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon4.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Monitoring Vital Signs</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Regularly checking heart rate, oxygen levels, and other vitals to track the patient’s condition.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/advicon4.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Patient Education</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Providing guidance to patients and caregivers on how to manage tracheostomy care at home.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
        </div>
      </div>
    </>
  );
}

export default Tracheostomycare;
